// extracted by mini-css-extract-plugin
module.exports = {"flashContent":"styles_flashContent__moQgN","flashContent_center":"styles_flashContent_center__cGXtE"};